import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFlightFormComponent } from './searchFlightForm.component';
import { SearchAirTripModule } from 'libraries/module/formbuilder/forms/searchAirTrip/searchAirTrip.module';
import { PermissionModule } from "libraries/permission/permission.module";
import { CardModule } from 'libraries/ui_card/card.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { FieldDescriptionModule } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.module";
import { ClickOutsideModule } from "libraries/ui_clickOutside/clickOutside.module";
import { PropalModule } from 'app_locobook/service/propal/propal.module';
import { CacheQuotedAvailabilityModule } from 'app_locobook/service/cache-quoted-availability/cache-quoted-availability.module';
import { QuoteService } from 'app_locobook/service/quote.service';
import { FormBuilderService } from 'libraries/service/formBuilder/formBuilder.service';
import { TravellerModule } from 'app_locobook/service/traveller/traveller.module';
import {
    DictionaryRoutesHostsRessourceModule,
} from "../../libraries/service/resources/dictionary-routes-hosts/dictionary-routes-hosts-ressource.module";
import {
    DictionarySearchResourceModule
} from "../../libraries/service/resources/dictionary-search/dictionary-search-resource.module";

@NgModule({
    imports: [
        CommonModule,
        SearchAirTripModule,
        PermissionModule,
        CardModule,
        BtnModule,
        FieldDescriptionModule,
        ClickOutsideModule,
        PropalModule,
        CacheQuotedAvailabilityModule,
        TravellerModule,
        DictionarySearchResourceModule,
        DictionaryRoutesHostsRessourceModule
    ],
    declarations: [
        SearchFlightFormComponent,
    ],
    exports: [
        SearchFlightFormComponent,
    ],
    providers: [QuoteService, FormBuilderService],
})
export class SearchFlightFormModule {
}
